<template>
  Press <span>{{ formatHotkey(keyAt) }}</span> to reference an object, add an
  integration etc.
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { hotkeys } from "@/utils/hotkeys";
import { keymap } from "@/utils/keymap";

export default defineComponent({
  name: "AgentPlaceholder",
  props: {
    mentionsEnabled: { type: Boolean, default: false },
  },
  setup() {
    return {
      formatHotkey: hotkeys.format.stringify,
      keyAt: keymap.keyAt,
    };
  },
});
</script>
